import { createBlock as e, createElementBlock as t, defineComponent as n, normalizeClass as r, openBlock as i, renderSlot as a, unref as o } from "vue";
import { ScalarIconMinus as s, ScalarIconPlus as c } from "@scalar/icons";
//#region src/schema/SchemaGlyphPuck.vue?vue&type=script&setup=true&lang.ts
var l = /*@__PURE__*/ n({
	__name: "SchemaGlyphPuck",
	props: {
		open: { type: Boolean },
		floating: {
			type: Boolean,
			default: !0
		},
		anchor: { default: "middle" }
	},
	setup(n) {
		return (l, u) => (i(), t("span", {
			"aria-hidden": "true",
			class: r(["schema-glyph tree-control-hover:bg-b-1 tree-control-hover:text-c-1 tree-control-hover:border-(--scalar-border-color) print:bg-transparent [&_svg]:size-[var(--schema-glyph-icon,16px)]", n.floating ? ["absolute start-[calc(0px_-_var(--schema-glyph-half,9px)_-_var(--schema-gutter,16px))] -translate-y-1/2", n.anchor === "line" ? "top-[0.5lh]" : "top-1/2"] : void 0])
		}, [a(l.$slots, "default", {}, () => [n.open ? (i(), e(o(s), {
			key: 0,
			weight: "light"
		})) : (i(), e(o(c), {
			key: 1,
			weight: "light"
		}))])], 2));
	}
});
//#endregion
export { l as default };

//# sourceMappingURL=SchemaGlyphPuck.vue.script.js.map